import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getSocialProfile } from 'action-creators/user';
import { socialUserProfileUpdate } from 'action-creators/social/user/profile/update';
import Metrics from 'services/metrics';
import { getLabels } from './constants';
import PublicProfile from './publicProfile';

function PublicProfileSection({
  profile,
  gamificationId,
  onSocialProfile,
  onUpdateSocialProfile,
}) {
  const labels = getLabels();
  const [isPrivate, setIsPrivate] = useState(true);
  const [loaded, setLoaded] = useState(true);

  useEffect(() => {
    onSocialProfile(gamificationId);
    return () => console.log('unmount MyAccount');
  }, []);

  useEffect(
    () => {
      if (profile) {
        setIsPrivate(profile.isPrivate);
        setLoaded(false);
      }
    },
    [profile],
  );

  const handleChange = () => {
    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',
      eventAction: 'Perfil Público',
      eventLabel: !isPrivate ? 'Desactivar' : 'Activar',
    });

    const params = {};
    params.metadatas = {};
    params.isPrivate = !isPrivate;
    params.id = profile.id;
    params.userId = profile.id;
    params.metadatas.name = profile.username;
    params.partnerName = profile.partnerName;
    params.partnerUserId = profile.partnerUserId;
    onUpdateSocialProfile(params);
    setIsPrivate(!isPrivate);
  };

  return (
    <PublicProfile
      label={labels}
      isPrivate={!isPrivate}
      onChange={handleChange}
      loading={loaded}
    />
  );
}

PublicProfileSection.propTypes = {
  profile: PropTypes.object,
  gamificationId: PropTypes.string,
  onSocialProfile: PropTypes.func.isRequired,
  onUpdateSocialProfile: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  profile: state.user.loggedInProfile,
  gamificationId: state.user.gamification_id,
});

const mapDispatchToProps = dispatch => ({
  onUpdateSocialProfile(payload) {
    dispatch(socialUserProfileUpdate(payload));
  },
  onSocialProfile(gamificationId) {
    dispatch(getSocialProfile(gamificationId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PublicProfileSection);
